var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('security-training-promo',{attrs:{"security-configuration-path":_vm.securityConfigurationPath,"project-full-path":_vm.projectFullPath},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var buttonLink = ref.buttonLink;
var buttonText = ref.buttonText;
var dismiss = ref.dismiss;
var trackCTAClick = ref.trackCTAClick;
return [_c('gl-banner',{attrs:{"title":_vm.$options.i18n.title,"button-text":buttonText,"button-link":buttonLink,"variant":"introduction"},on:{"primary":trackCTAClick,"close":dismiss}},[_c('p',[_vm._v(_vm._s(_vm.$options.i18n.content))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }